import React from "react";
import {readableDate} from "../../utils";
import { Checkbox, TextArea } from "@allxsmith/bestax-bulma";


export default function InvoiceSectionRow({invoice}){


    return (
        <tr>
            <td>{invoice.id}</td>
            <td>{invoice.quantity}</td>
            <td>£{invoice.amount}</td>
            <td>£{invoice.no_vat_amount}</td>
            <td>{readableDate(invoice.invoice_date)}</td>
            <td>{invoice.invoice_number}</td>
            <td>{invoice.approved ? "Yes" : "No"}</td>
            <td>{invoice.approver ? invoice.approver.first_name + " " + invoice.approver.last_name : ""}</td>
            <td>
                <TextArea
                    disabled={true}
                    value={invoice.description}
                />
            </td>
            <td>
                <TextArea
                    disabled={true}
                    value={invoice.comments}
                />
            </td>
            <td>
                <Checkbox
                    checked={invoice.hide}
                />
            </td>
        </tr>
    );

}